// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RequirementVMMapper$PorterinFeature from "../view-model/RequirementVMMapper.mjs";
import * as FareEstimateReqRadioCmp$PorterinFeature from "./FareEstimateReqRadioCmp.mjs";
import * as FareEstimateRequirementModuleScss from "../styles/FareEstimateRequirement.module.scss";

var default_styles = FareEstimateRequirementModuleScss;

function FareEstimateReqRadioGroupCmp(Props) {
  var requirement = Props.requirement;
  var onChange = Props.onChange;
  var disabled = Props.disabled;
  var stylesOpt = Props.styles;
  var requirement_labels = Props.requirement_labels;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : default_styles;
  return React.createElement("div", {
              className: styles["requirement-radiogroup"]
            }, Belt_List.toArray(Belt_List.mapWithIndex(RequirementVMMapper$PorterinFeature.getRequirementList(undefined), (function (index, req) {
                        return React.createElement(FareEstimateReqRadioCmp$PorterinFeature.make, {
                                    requirement: req,
                                    onChange: onChange,
                                    checked: RequirementVMMapper$PorterinFeature.isRequirementChecked(requirement, req),
                                    disabled: disabled,
                                    styles: styles,
                                    requirement_labels: requirement_labels,
                                    key: String(index)
                                  });
                      }))));
}

var make = FareEstimateReqRadioGroupCmp;

export {
  default_styles ,
  make ,
}
/* default_styles Not a pure module */
